// extracted by mini-css-extract-plugin
module.exports = {"link":"_1410bfd27b--link--X9a5a","icon":"_1410bfd27b--icon--CFC_w","content":"_1410bfd27b--content--aV_Pt"};